export default __webpack_public_path__ + "static/media/ic_file_download_48px.a0cb72e7.svg";